import { render, staticRenderFns } from "./FundSort.vue?vue&type=template&id=3906dee7&scoped=true&"
import script from "./FundSort.vue?vue&type=script&lang=js&"
export * from "./FundSort.vue?vue&type=script&lang=js&"
import style0 from "./FundSort.vue?vue&type=style&index=0&id=3906dee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906dee7",
  null
  
)

export default component.exports